export default "__VITE_ASSET__5d71504a__"